import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { TrashIcon } from '@heroicons/react/outline';

import { removeFromCart, addToCart } from '../redux/actions';
import { formatCurrency, sumCartPrice } from '../utils';
import { Select, Button, Divider } from '.';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export function CartBody({ isDrawer }) {
  const { items } = useSelector((state) => state?.cartItems);
  const dispatch = useDispatch();

  const addItemToCart = (e, product) => {
    dispatch(addToCart(product, parseInt(e.target.value)));
  };

  return (
    <>
      {items.length ? (
        <div className="my-6">
          <div className="flow-root">
            <ul role="list" className="-my-6 divide-y divide-gray-200">
              {items.map((item) => (
                <li key={item._id} className="py-6 flex">
                  <div className="flex-shrink-0 w-24 h-24 border border-gracentery-200 rounded-md overflow-hidden">
                    <img
                      src={item.imageSrc}
                      alt={item.name}
                      className="w-full h-full object-center object-cover"
                    />
                  </div>

                  <div className="flex justify-center ml-4 flex-1 flex flex-col">
                    <div>
                      <div className="flex justify-between text-base font-medium text-gray-900">
                        <h3 className="text-gray-600 font-normal">
                          {item.name}
                        </h3>
                        {isDrawer && (
                          <button
                            onClick={() => dispatch(removeFromCart(item))}
                          >
                            <TrashIcon className="h-6 w-6 text-sky-500" />
                          </button>
                        )}
                      </div>
                    </div>
                    <div className="mt-2 flex items-end justify-between items-center text-sm">
                      <p className="text-gray-700 font-bold text-base">
                        {formatCurrency(item.price)}
                      </p>

                      <div className="flex">
                        {isDrawer ? (
                          <Select
                            handleOnChange={(e) => addItemToCart(e, item)}
                            optionList={[...Array(10)].map((_, ind) => ({
                              name: ind + 1,
                              value: ind + 1,
                            }))}
                            selectedValue={item.qty}
                          />
                        ) : (
                          <p className="text-gray-500">Qty {item.qty}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ) : (
        <div className="py-4 text-gray-500">Cart is empty.</div>
      )}
    </>
  );
}

export function CartFooter({ setOpen, isDrawer }) {
  const { items } = useSelector((state) => state?.cartItems);

  let navigate = useNavigate();

  const navigateToPage = (page) => {
    navigate(page);
    setOpen(false);
  };

  const subTotal = sumCartPrice(items);
  const shippingFee = 5;
  const total = subTotal + shippingFee;

  return (
    <>
      {items.length > 0 && (
        <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
          <div
            className={classNames(
              isDrawer ? 'font-bold' : 'font-normal',
              'flex justify-between text-base font-sm text-gray-900'
            )}
          >
            <p>Subtotal</p>
            <p>{formatCurrency(subTotal)}</p>
          </div>
          {!isDrawer ? (
            <>
              <div className="flex justify-between text-base font-sm font-normal text-gray-900 my-4">
                <p>Shipping</p>
                <p>{formatCurrency(shippingFee)}</p>
              </div>
              <div className="flex justify-between text-base font-sm font-normal text-gray-900">
                <p>Taxes</p>
                <p>{formatCurrency(0)}</p>
              </div>
              <Divider />
              <div className="flex justify-between text-base font-sm font-bold text-gray-900">
                <p>Total</p>
                <p>{formatCurrency(total)}</p>
              </div>
            </>
          ) : (
            <p className="mt-0.5 text-sm text-gray-500">
              Shipping and taxes calculated at checkout.
            </p>
          )}

          {isDrawer && (
            <div className="mt-6">
              <Button
                full
                label="Checkout"
                handleClick={() => navigateToPage('/checkout')}
              />
            </div>
          )}
          {isDrawer && (
            <div className="mt-6 flex justify-center text-sm text-center text-gray-500">
              <p>
                or{' '}
                <button
                  type="button"
                  className="text-sky-600 font-medium hover:text-sky-500"
                  onClick={() => navigateToPage('/')}
                >
                  Continue Shopping
                  <span aria-hidden="true"> &rarr;</span>
                </button>
              </p>
            </div>
          )}
        </div>
      )}
    </>
  );
}
